import React from "react";
import styles from '../styles/dailyCashRewards.module.scss'
import InviteInfo from "./inviteInfo";
import EventDetails from "./eventDetails";
import FadeIn from "@/compoments/fadeIn";
import { useTranslation } from "react-i18next";

const DailyCashRewards = ({currentIndex, baseConfigData, activityBetTaskData}) => {
  const { t } = useTranslation('inviteFriends')
  const rulesList = baseConfigData?.list?.[2]

  const infoList = [
    {
      content: activityBetTaskData?.friendBetSum,
      title: t('dailyCashRewards.friendTotalBet'),
    },
    {
      content: activityBetTaskData?.needRebateSum,
      title: t('dailyCashRewards.accumulatedRebate'),
    },
    {
      content: activityBetTaskData?.alreadyRebateSum,
      title: t('dailyCashRewards.totalRebateGiven'),
    },
  ]

  return (
    <FadeIn>
    <div className={styles.dailyCashRewards}>

      {/* 图片 推荐链接等 */}
      <InviteInfo list={infoList} />

      {/* 活动内容 */}
      <EventDetails rulesList={rulesList} currentIndex={currentIndex}/>
      
    </div>
    </FadeIn>
  )
}

export default DailyCashRewards